<template>
  <div id="search-box" class="w-full">
    <vx-card :title="title" noShadow :cardBorder="showBorder">
      <vue-simple-suggest
        ref="vueSimpleSuggest"
        mode="select"
        :styles="autoCompleteStyle"
        v-model="choosen"
        :list="searchOptions"
        :filter-by-query="true"
        value-attribute="id"
        display-attribute="title"
      >
        <div class="vs-component vs-con-input-label vs-input w-full input-full vs-input-primary">
          <div class="vs-con-input">
            <input
              type="search"
              placeholder="Search"
              class="vs-inputx vs-input--input normal hasIcon"
              style="border: 1px solid rgba(0, 0, 0, 0.2);"
            />
            <i
              class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-search null icon-no-border"
            >
            </i>
          </div>
        </div>
      </vue-simple-suggest>

      <vs-list class="list-container">
        <vs-list-item v-if="options.length === 0" title="No data" class="disabled"> </vs-list-item>

        <draggable v-else v-model="options" class="cursor-move">
          <vs-list-item v-for="(option, index) in options" :key="`searchItem${index}`" :title="option.title">
            <template slot="avatar">
              {{ index + 1 }}.
              <vs-avatar :src="option[thumbnailField]" size="large" class="rounded mx-5" color="white" />
            </template>

            <span @click="handleDelete(option)" class="cursor-pointer">
              <vs-icon icon="close"></vs-icon>
            </span>
          </vs-list-item>
        </draggable>
      </vs-list>
    </vx-card>
  </div>
</template>

<script>
import VueSimpleSuggest from 'vue-simple-suggest';
import draggable from 'vuedraggable';

export default {
  components: {
    VueSimpleSuggest,
    draggable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    max: {
      type: Number,
      required: false,
    },
    datasourceAction: {
      type: String,
      required: false,
      default() {
        return 'product/getProducts';
      },
    },
    datasourceModule: {
      type: String,
      required: false,
      default() {
        return 'product';
      },
    },
    datasourceState: {
      type: String,
      required: false,
      default() {
        return 'products';
      },
    },
    showBorder: {
      type: Boolean,
      required: false,
      default: true,
    },
    thumbnailField: {
      type: String,
      required: false,
      default: 'iconUrl',
    },
  },
  data() {
    return {
      choosen: '',
      autoCompleteStyle: {
        suggestions: 'custom-suggestions',
      },
    };
  },
  computed: {
    options: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    datasource() {
      return this.$store.state[this.datasourceModule][this.datasourceState];
    },
    selected() {
      return this.value.map(({ id }) => id) || [];
    },
    searchOptions() {
      return this.datasource
        .filter(d => {
          return !this.selected.includes(d.id);
        })
        .map(({ id, title, iconUrl, imageUrl }) => ({ id, title, iconUrl, imageUrl }));
    },
  },
  methods: {
    handleDelete(d) {
      this.$emit(
        'input',
        this.value.filter(o => o.id !== d.id),
      );
    },
  },
  mounted() {
    this.$store.dispatch(this.datasourceAction, {limit: 9999});
  },
  watch: {
    choosen(value) {
      if (value) {
        if (this.max && this.value.length >= this.max) {
          this.value[this.value.length - 1] = value;
        } else {
          this.value.push(value);
        }

        this.$emit('input', this.value);
        this.$refs.vueSimpleSuggest.setText('');
      }
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/vuexy/extraComponents/autocomplete.scss';
#search-box {
  .list-container {
    margin-top: 10px;
    max-height: 300px;
    overflow: scroll;
    overflow-y: auto;
    overflow-x: hidden;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
  }

  .custom-suggestions {
    position: absolute;
    width: calc(100% - 1.5rem * 2);
    border-radius: 3px;
    border: 1px solid #aaa;
    background-color: #fff;
    z-index: 1000;
  }
}
</style>
